import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ProjectRegistrationHelper } from '../project.registration.helper';

@Component({
	selector: 'project-registration-modules',
	template: require('./project.registration.modules.html'),
})
export class ProjectRegistrationModulesComponent implements OnInit {
	@Input() projectForm: UntypedFormGroup;

	modules = [];

	constructor(
		protected projectRegistrationHelper: ProjectRegistrationHelper,
	) {
	}

	ngOnInit(): void {
		const v = this.projectForm.get('modules')?.value;
		if (v) {
			this.modules = v.split(',');
		}
		console.log('ProjectRegistrationModulesComponent', this.modules);
	}

	setModuleEnabled(event: { enabled: boolean; module: any }): void {
		if (event.enabled) {
			this.modules = [...new Set(_.concat(this.modules, [event.module]))];
		} else {
			this.modules = _.without(this.modules, event.module);
		}
		this.updateFormField();
	}

	setScmModule(module: any): void {
		this.modules = _.filter(
			_.difference(this.modules, this.projectRegistrationHelper.availableScmModules)
				.concat([module])
		);
		this.updateFormField();
	}

	updateFormField() {
		const newValue = this.modules.join(',');
		const control = this.projectForm.get('modules');
		control.setValue(newValue);
	}
}
